import { styles } from '@src/components/Search/Navigate/Select/styles';
import React from 'react';
import Select from 'react-select';

const ALevelFilters = ({
  filterControls,
  selectedModules,
  selectedChapters,
  onModuleChange,
  onChapterChange,
}) => {
  if (!filterControls.moduleValues?.length && !filterControls.chapterValues?.length) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '1rem',
        alignItems: 'center',
      }}
    >
      {filterControls.moduleValues?.length > 0 && (
        <div style={{ minWidth: '200px', maxWidth: '300px' }}>
          <Select
            isMulti
            options={filterControls.moduleValues.map((value) => ({
              value,
              label: value,
            }))}
            value={filterControls.moduleValues
              .filter((value) => selectedModules.includes(value))
              .map((value) => ({ value, label: value }))}
            onChange={onModuleChange}
            placeholder="Select modules..."
            isClearable
            styles={styles}
          />
        </div>
      )}

      {filterControls.chapterValues?.length > 0 && (
        <div style={{ minWidth: '200px', maxWidth: '300px' }}>
          <Select
            isMulti
            options={filterControls.chapterValues.map((value) => ({
              value,
              label: `Chapter ${value}`,
            }))}
            value={filterControls.chapterValues
              .filter((value) => selectedChapters.includes(value))
              .map((value) => ({ value, label: `Chapter ${value}` }))}
            onChange={onChapterChange}
            placeholder="Select chapters..."
            isClearable
            styles={styles}
          />
        </div>
      )}
    </div>
  );
};

export default ALevelFilters;
